/**
 * v-db-click 防重复点击（对齐 EB view/mer/src/directive/dbClick.js）
 * Vue3：mounted 阶段绑定，避免连点重复提交
 */
import type { Directive } from 'vue';

const lockKey = '__dbClickLock__';
const handlerKey = '__dbClickHandler__';

const dbClick: Directive = {
  mounted(el) {
    const handler = (e: MouseEvent) => {
      if ((el as any)[lockKey]) {
        e.stopImmediatePropagation?.();
        e.preventDefault();
        return;
      }
      (el as any)[lockKey] = true;

      const isButtonLike =
        el instanceof HTMLButtonElement ||
        el.classList?.contains('el-button') ||
        el.getAttribute?.('role') === 'button';
      if (isButtonLike) {
        el.setAttribute?.('disabled', 'disabled');
        el.classList?.add('is-disabled');
      } else {
        el.style.cursor = 'not-allowed';
        el.style.pointerEvents = 'none';
      }

      window.setTimeout(() => {
        (el as any)[lockKey] = false;
        if (isButtonLike) {
          el.removeAttribute?.('disabled');
          el.classList?.remove('is-disabled');
        } else {
          el.style.cursor = '';
          el.style.pointerEvents = '';
        }
      }, 1000);
    };

    el.addEventListener('click', handler, true);
    (el as any)[handlerKey] = handler;
  },
  unmounted(el) {
    const handler = (el as any)[handlerKey];
    if (handler) el.removeEventListener('click', handler, true);
    delete (el as any)[handlerKey];
    delete (el as any)[lockKey];
  },
};

export default dbClick;
